import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';


const Rate = ({ count, rating, color, onRating, isReadOnly, size }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const getColor = (index) => {
    if (hoverRating >= index) {
      return color.filled;
    } else if (!hoverRating && rating >= index) {
      return color.filled;
    }

    return color.unfilled;
  };

  const starRating = useMemo(() => {
    return Array(count)
      .fill(0)
      .map((_, i) => i + 1)
      .map((idx) =>
        isReadOnly ? (
          <FontAwesomeIcon
            icon={faStar}
            style={{ color: getColor(idx) }}
            className='text-center'
            size={size}
            key={idx}
          />
        ) : (
          <FontAwesomeIcon
            key={idx}
            className="cursor-pointer text-center"
            icon={faStar}
            onClick={() => onRating(idx)}
            style={{ color: getColor(idx) }}
            onMouseEnter={() => setHoverRating(idx)}
            onMouseLeave={() => setHoverRating(0)}
            size={size}
          />
        )
      );
  }, [count, rating, hoverRating]);

  return <div>{starRating}</div>;
};
export default Rate;
